<template>
    <div class="container">
        <b-modal
            :model-value="showDialogCreate"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-item">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <h5>{{labels.name}}</h5>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="nombre" type="text" class="reset-input"></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <h5>{{labels.description}}</h5>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-textarea v-model="descripcion" rows="3" max-rows="6" class="reset-input"></b-form-textarea>
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeModal()">{{ labels.cerrar }}</b-button>
                    <b-button class="reset-btn-primary" @click="guardaInfoRol()">{{ labels.guardar }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Roles from '../../services/Roles'; 

export default {
    name:'Create',
    props:['showDialogCreate'],
    data: () => ({
        nombre : "",
        descripcion : "",
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    title : 'Crear Rol',
                    name : "Nombre:",
                    description : "Descripción:",
                    guardar : 'Guardar',
                    cerrar : 'Cerrar',
                    infoTitle: 'Datos del rol',
                    infoText: 'Completa la información y guarda el nuevo rol.'
                }
            }else{
                return {
                    title : 'Create Rol',
                    name : "Name:",
                    description : "Description:",
                    guardar : 'Save',
                    cerrar : 'Close',
                    infoTitle: 'Role information',
                    infoText: 'Complete the information and save the new role.'
                }
            }
        }
    },
    methods: {
        closeModal(){
            this.$emit('closeModal',false) 
        },
        guardaInfoRol(){
            if(this.nombre == ""){ 
                this.$toast.error('Diligenciar el nombre') 
            
            }else if(this.descripcion == ""){ 
                this.$toast.error('Diligenciar la descripción') 

            }else{
                let infoForm = {
                    'nombre' : this.nombre, 
                    'descripcion' : this.descripcion, 
                    'idUser' : this.$store.state.userId 
                }
                // console.log(infoForm) 

                Roles.createRol(infoForm) 
                .then((res) => { 
                    if(res.status == 201){ 
                        this.$toast.success('Rol creado.') 
                        location. reload() 
                    }
                })
                .catch((error) => { 
                    console.log(error) 
                })
            }
        }
    }
}
</script>

<style>

</style>
